var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex float-left vertical-center"},[_c('vs-chip',{staticClass:"line-0",attrs:{"color":_vm.statusColor}},[_vm._v("\n        "+_vm._s(_vm.statusText)+"\n    ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }